/**
 * @file MypageBtnMargin
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname MypageBtnMargin
 * @classdesc MypageBtnMargin
 */
export default class MypageBtnMargin {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('MypageBtnMargin.constructor')
		this._$e = $e;
		this._$parent = $e.parent('.block--btn-section')

		this._settingMargin()
		
		$(window).on('resize', () => this.onResize());
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof MypageBtnMargin
	 * @return {undefined}
	 */
	 onResize() {
		console.log('MypageBtnMargin.onResize');
		this._settingMargin()
	 }

	/**
	 *
	 * @memberof MypageBtnMargin
	 * @return {undefined}
	 */
	_settingMargin() {
		const w = this._$parent.width();
		const b_width = 101

		const gap = $(window).width() > 768 ? 12 : 10

		const i = parseInt (w / b_width )
		const b_num  = ( w - b_width * i ) - gap * ( i - 1 ) > 0 ? i  : i - 1
		const width = b_width * b_num + gap * ( b_num - 1)
		
		this._$e.css('width', width)
	};

}
